export enum ZIndex {
    PasswordFieldIcon= 2,
    StickyHeaders = 5,
    MainHeader = 8,
    Modal = 3000,
    DropDownPopper = 5000,
    LoadingIndicator = 30000
}
